(function($) { "use strict";
	if( $('.tickets-availability__title').length ) {
		//Show tickets availability on click
		$('.tickets-availability__title').click( function(e) {
			e.preventDefault();
			$('.tickets-availability__content').toggleClass('active');
		});
	}
})(jQuery);